import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import axios from 'axios'
import Element from 'element-ui'
import echarts from 'echarts'

import Content from './components/Content.vue'
import ResultsList from './components/ResultList.vue'
import ResultStatistics from './components/ResultStatistics.vue'
import BatchStatisticsResult from './components/BatchStatisticsResult.vue'
import ResultDetail from './components/ResultDetail.vue'
import Login from './components/Login.vue'
import Register from './components/Register.vue'
import AdminUsers from './components/AdminUsers.vue'
import AdminModels from './components/AdminModels.vue'
import Test3D from './components/Test3D.vue'

import '../node_modules/element-ui/lib/theme-chalk/index.css'
import '../src/assets/style.css'
import './theme/index.css'
import { i18n } from './i18n'

Vue.prototype.$echarts = echarts
Vue.use(Element)
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.prototype.$http = axios

const router = new VueRouter({
    routes: [
        { path: '/login', component: Login, meta: { title: '登录', requiresAuth: false } },
        { path: '/register', component: Register, meta: { title: '注册', requiresAuth: false } },
        { path: '/admin/users', component: AdminUsers, meta: { title: '账号管理', requiresAuth: true } },
        { path: '/admin/models', component: AdminModels, meta: { title: '模型更新', requiresAuth: true } },
        { path: '/test3d', component: Test3D, meta: { title: '3D测试页面', requiresAuth: false } },
        { path: '/', component: Content, meta: { title: '上传与处理', requiresAuth: true } },
        { path: '/results', component: ResultsList, meta: { title: '结果列表', requiresAuth: true } },
        { path: '/results/statistics', component: ResultStatistics, meta: { title: '统计结果', requiresAuth: true } },
        { path: '/results/batch-statistics', component: BatchStatisticsResult, meta: { title: '批量统计结果', requiresAuth: true } },
        { path: '/results/:patient/:date', component: ResultDetail, meta: { title: '结果详情', requiresAuth: true } },
        { path: '*', redirect: '/' }
    ],
    mode: 'hash'
})

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('access_token')
    const skipAuth = process.env.VUE_APP_SKIP_AUTH === 'true'
    const requiresAuth = to.meta.requiresAuth !== false
    const isAuthPage = to.path === '/login' || to.path === '/register'

    if (skipAuth && isAuthPage) {
        next('/')
    } else if (requiresAuth && !token && !skipAuth) {
        next('/login')
    } else if (isAuthPage && token) {
        next('/')
    } else {
        next()
    }
})

Vue.component('App', App)

new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App)
})
